import { render, staticRenderFns } from "./detailEdit.vue?vue&type=template&id=52de7dc1&scoped=true&"
import script from "./detailEdit.vue?vue&type=script&lang=js&"
export * from "./detailEdit.vue?vue&type=script&lang=js&"
import style0 from "./detailEdit.vue?vue&type=style&index=0&id=52de7dc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de7dc1",
  null
  
)

export default component.exports